<template lang="pug">
modal#warning-change-envelope-reviewer-modal(
  :no-footer='true'
  :title='$t("pages.waiting-review.modal.title")'
  ref='modal'
  size='sm'
)
  .text-start {{ $t('pages.waiting-review.modal.changeReviewerMessage') }}
  .text-start {{ $t('pages.waiting-review.modal.changeReviewer') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/warning-envelope.svg')
  .text-end.mt-5
    button.btn.btn-secondary.me-2(
      @click='changeEnvelopeReviewer(true)'
      data-bs-dismiss='modal'
      type='button'
    )
      span.text {{ $t('pages.waiting-review.modal.processButton') }}
    button.btn.btn-danger(
      @click='changeEnvelopeReviewer(false)'
      data-bs-dismiss='modal'
      type='button'
    )
      span.text {{ $t('pages.waiting-review.modal.closeButton') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'WarningChangeEnvelopeReviewerModal',
  components: {
    Modal,
  },
  methods: {
    changeEnvelopeReviewer(event) {
      this.$emit('changeEnvelopeReviewer', event);
    },
  },
};
</script>
